import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { environment } from "../../environments/environment";
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { CognitoCallback, CognitoUtilService, LoggedInCallback } from "./cognito-util.service";
let jwtDecode = require('jwt-decode');
import * as AWS from "aws-sdk/global";
import * as STS from "aws-sdk/clients/sts";

import {
  CognitoUserPool,
  CognitoUserAttribute,
  CognitoUser,
  AuthenticationDetails,
  CognitoUserSession
} from 'amazon-cognito-identity-js';

import { User } from './user.model';

const POOL_DATA = {
  UserPoolId: environment.userPoolId,
  ClientId: environment.clientId
};
const userPool = new CognitoUserPool(POOL_DATA);

@Injectable()
export class AuthService {
  authIsLoading = new BehaviorSubject<boolean>(false);
  authDidFail = new BehaviorSubject<boolean>(false);
  authErrorMsg = new BehaviorSubject<any>(null);
  userGroup = new BehaviorSubject<string>(null);
  authStatusChanged = new Subject<boolean>();
  registeredUser: CognitoUser;
  

  constructor(private router: Router, public cognitoUtil: CognitoUtilService) {
  }

  signUp(username: string, email: string, password: string): void {
    this.authIsLoading.next(true);
    const user: User = {
      username: username,
      email: email,
      password: password
    };
    const attrList: CognitoUserAttribute[] = [];
    const emailAttribute = {
      Name: 'email',
      Value: user.email
    };
    attrList.push(new CognitoUserAttribute(emailAttribute));
    userPool.signUp(user.username, user.password, attrList, null, (err, result) => {
      if (err) {
        this.authDidFail.next(true);
        this.authIsLoading.next(false);
        return;
      }
      this.authDidFail.next(false);
      this.authIsLoading.next(false);
      this.registeredUser = result.user;
    });
    return;
  }

  confirmUser(username: string, code: string) {
    this.authIsLoading.next(true);
    const userData = {
      Username: username,
      Pool: userPool
    };
    const cognitUser = new CognitoUser(userData);
    cognitUser.confirmRegistration(code, true, (err, result) => {
      if (err) {
        this.authDidFail.next(true);
        this.authIsLoading.next(false);
        return;
      }
      this.authDidFail.next(false);
      this.authIsLoading.next(false);
      this.router.navigate(['/']);
    });
  }

  signIn(username: string, password: string, newPassword): void {
    console.log('AuthService signIn()', username, password, newPassword );
    
    this.authIsLoading.next(true);
    const authData = {
      Username: username,
      Password: password
    };
    const authDetails = new AuthenticationDetails(authData);
    const userData = {
      Username: username,
      Pool: userPool
    };
    const cognitoUser = new CognitoUser(userData);
    const that = this;
    cognitoUser.authenticateUser(authDetails, {
      newPasswordRequired (userAttributes: any, requiredAttributes: any) {
        console.log('userAttributes: ',userAttributes,  ' requiredAttributes: ',requiredAttributes);
        if (newPassword){
          delete userAttributes.email_verified;
          cognitoUser.completeNewPasswordChallenge(newPassword, requiredAttributes, {
            onSuccess: function (result) {
              console.log('userAttributes: ', userAttributes);
              that.authStatusChanged.next(true);
              that.authDidFail.next(false);
              that.authIsLoading.next(false);
              that.authErrorMsg.next(null);
            },
            onFailure: function (err) {
              //callback.cognitoCallback(err, null);
              console.log('err: ', err);
              that.authErrorMsg.next(err);
            }
          });
        }
        else {
          that.authIsLoading.next(false);
          that.authErrorMsg.next({message: 'User needs to set password.'});
        }
        
        
      },
      onSuccess (result: CognitoUserSession) {
        console.log('AuthService signIn() cognitoUser.authenticateUser() onSuccess', result );
        
        let creds = that.cognitoUtil.buildCognitoCreds(result.getIdToken().getJwtToken());
        console.log("creds ",creds);
        AWS.config.credentials = creds;
        console.log(result);

        that.authStatusChanged.next(true);
        that.authDidFail.next(false);
        that.authIsLoading.next(false);
        that.authErrorMsg.next(null);
        

      },
      onFailure(err) {
        console.log('AuthService signIn() cognitoUser.authenticateUser() onFailure', err );
        that.authDidFail.next(true);
        that.authIsLoading.next(false);
        that.authErrorMsg.next(err);
        console.log(err);
        
      }
    });
   // this.authStatusChanged.next(true); // create user with cognito data
    return;
  }

  getAuthenticatedUser() {
    return userPool.getCurrentUser();
  }

  getUserGroup(){
      return this.userGroup;
  }

  logout() {
    this.getAuthenticatedUser().signOut();
    this.authStatusChanged.next(false);
    this.userGroup.next(null);
    this.authErrorMsg.next(null);
  }

  isAuthenticated(): Observable<boolean> {
    const user = this.getAuthenticatedUser();
    const obs = Observable.create((observer) => {
      if (!user) {
        observer.next(false);
      } else {
        user.getSession((err, session) => {
          if (err) {
            observer.next(false);
          } else {
            if (session.isValid()) {
              let creds = this.cognitoUtil.buildCognitoCreds(session.getIdToken().getJwtToken());
              console.log("creds ",creds);
              AWS.config.credentials = creds;

              let userGroup = jwtDecode(session.getAccessToken().getJwtToken())['cognito:groups'];
              console.log('this.userGroup: ', userGroup);
              this.userGroup.next(userGroup);
              observer.next(true);
            } else {
              observer.next(false);
            }
          }
        });
      }
      observer.complete();
    });
    return obs;
  }

  initAuth() {
    this.isAuthenticated().subscribe(
      (auth) => this.authStatusChanged.next(auth)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/service/auth.service.ts